import { render, staticRenderFns } from "./DdTextArea.vue?vue&type=template&id=26db5570&scoped=true&"
import script from "./DdTextArea.vue?vue&type=script&lang=js&"
export * from "./DdTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26db5570",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTextarea,VTooltip})
